var _defs, _rect, _path, _path2, _path3, _text, _path4, _path5, _path6, _path7, _text2, _path8, _path9, _path10, _text3, _rect2, _text4, _rect3, _text5, _rect4, _text6, _path11, _path12, _rect5, _text7, _path13, _path14, _rect6, _text8, _path15, _path16, _rect7, _text9, _path17, _path18, _rect8, _text10, _path19, _rect9, _text11, _path20, _rect10, _text12, _path21, _rect11, _text13, _rect12, _text14, _path22, _path23, _rect13, _text15, _path24, _rect14, _text16, _rect15, _text17, _rect16, _text18, _rect17, _text19, _rect18, _text20, _rect19, _text21, _rect20, _text22, _rect21, _text23, _rect22, _text24, _rect23, _text25, _rect24, _text26, _path25, _path26, _path27, _text27, _path28, _path29, _path30, _text28, _switch;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestdrawio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    host: "65bd71144e",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1132px",
    height: "432px",
    viewBox: "-0.5 -0.5 1132 432",
    content: "<mxfile><diagram id=\"Ky6q3QqwDpv0OaLa-dUS\" name=\"Page-1\">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</diagram></mxfile>",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 880,
    y: 0,
    width: 250,
    height: 430,
    rx: 37.5,
    ry: 37.5,
    fill: "#1f1f1f",
    stroke: "#ffffff",
    pointerEvents: "all"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 470 150 L 520 150 L 550 180 L 550 250 L 470 250 L 470 150 Z",
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 520 150 L 520 180 L 550 180 Z",
    fillOpacity: 0.05,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 520 150 L 520 180 L 550 180",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 78,
      height: 1,
      paddingTop: 200,
      marginLeft: 471
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "\n                                CaseFile\n                            ")))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 510,
    y: 204,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "14px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "\n                    CaseFile\n                ")))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 250 200 L 470 200",
    fill: "none",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    strokeDasharray: "12 12",
    pointerEvents: "stroke"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 170 150 L 220 150 L 250 180 L 250 250 L 170 250 L 170 150 Z",
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 220 150 L 220 180 L 250 180 Z",
    fillOpacity: 0.05,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 220 150 L 220 180 L 250 180",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 78,
      height: 1,
      paddingTop: 200,
      marginLeft: 171
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("b", {
    style: {
      fontSize: 14
    }
  }, "\n                                    CaseFile\n                                "))))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 210,
    y: 204,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "14px",
    textAnchor: "middle"
  }, "\n                    CaseFile\n                ")))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 965 150 L 1015 150 L 1045 180 L 1045 250 L 965 250 L 965 150 Z",
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 1015 150 L 1015 180 L 1045 180 Z",
    fillOpacity: 0.05,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M 1015 150 L 1015 180 L 1045 180",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 78,
      height: 1,
      paddingTop: 200,
      marginLeft: 966
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "\n                                CaseFile\n                            ")))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 1005,
    y: 204,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "14px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "\n                    CaseFile\n                ")))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 100,
    width: 140,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 138,
      height: 1,
      paddingTop: 115,
      marginLeft: 131
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #FFFFFF; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      fontFamily: "Helvetica",
      color: "rgb(255, 255, 255)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "\n                                Create new CaseFile\n                            ")))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 119,
    fill: "#FFFFFF",
    fontFamily: "Helvetica",
    fontSize: "14px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "\n                    Create new CaseFile\n                ")))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 415,
    y: 100,
    width: 190,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 188,
      height: 1,
      paddingTop: 115,
      marginLeft: 416
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #FFFFFF; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      fontFamily: "Helvetica",
      color: "rgb(255, 255, 255)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "\n                                Add data (entities) to CaseFile\n                            ")))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 510,
    y: 119,
    fill: "#FFFFFF",
    fontFamily: "Helvetica",
    fontSize: "14px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "\n                    Add data (entities) to Case...\n                ")))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 945,
    y: 100,
    width: 120,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 118,
      height: 1,
      paddingTop: 115,
      marginLeft: 946
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #FFFFFF; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      fontFamily: "Helvetica",
      color: "rgb(255, 255, 255)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "\n                                Submit CaseFile\n                            ")))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 1005,
    y: 119,
    fill: "#FFFFFF",
    fontFamily: "Helvetica",
    fontSize: "14px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "\n                    Submit CaseFile\n                ")))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M 10.5 205 L 10.5 195 L 150.5 195 L 150.5 184.5 L 169.5 200 L 150.5 215.5 L 150.5 205 Z",
    fill: "none",
    stroke: "#ffffff",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M 551.54 205 L 551.54 195 L 945.5 195 L 945.5 184.5 L 964.5 200 L 945.5 215.5 L 945.5 205 Z",
    fill: "none",
    stroke: "#ffffff",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 160,
    width: 160,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 158,
      height: 1,
      paddingTop: 175,
      marginLeft: 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #FFFFFF; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      fontFamily: "Helvetica",
      color: "rgb(255, 255, 255)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "\n                                POST api/v1/CaseFile\n                            ")))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 179,
    fill: "#FFFFFF",
    fontFamily: "Helvetica",
    fontSize: "14px",
    textAnchor: "middle"
  }, "\n                    POST api/v1/CaseFile\n                ")))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M 553.33 280 L 515.24 253.62",
    fill: "none",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M 510.92 250.64 L 518.67 251.74 L 515.24 253.62 L 514.68 257.5 Z",
    fill: "#ffffff",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 515,
    y: 370,
    width: 120,
    height: 60,
    fill: "rgb(255, 255, 255)",
    stroke: "#1f1f1f",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 118,
      height: 1,
      paddingTop: 400,
      marginLeft: 516
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "\n                                CustomEntity\n                            ")))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 575,
    y: 404,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "14px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "\n                    CustomEntity\n                ")))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M 336.67 280 L 463.79 251.4",
    fill: "none",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M 468.91 250.25 L 462.85 255.2 L 463.79 251.4 L 461.31 248.37 Z",
    fill: "#ffffff",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 370,
    width: 120,
    height: 60,
    fill: "rgb(255, 255, 255)",
    stroke: "#1f1f1f",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 118,
      height: 1,
      paddingTop: 400,
      marginLeft: 211
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "\n                                Contact\n                            ")))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 270,
    y: 404,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "14px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "\n                    Contact\n                ")))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M 453.33 280 L 504.37 252.98",
    fill: "none",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M 509.01 250.52 L 504.46 256.89 L 504.37 252.98 L 501.19 250.71 Z",
    fill: "#ffffff",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 365,
    y: 370,
    width: 120,
    height: 60,
    fill: "rgb(255, 255, 255)",
    stroke: "#1f1f1f",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 118,
      height: 1,
      paddingTop: 400,
      marginLeft: 366
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "\n                                CaseDocuments\n                            ")))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 425,
    y: 404,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "14px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "\n                    CaseDocuments\n                ")))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M 575 370 L 575 310",
    fill: "none",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 500,
    y: 280,
    width: 150,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 148,
      height: 1,
      paddingTop: 295,
      marginLeft: 501
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #FFFFFF; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      fontFamily: "Helvetica",
      color: "rgb(255, 255, 255)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "\n                                POST api/v1/CustomEntity\n                            ")))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 575,
    y: 299,
    fill: "#FFFFFF",
    fontFamily: "Helvetica",
    fontSize: "14px",
    textAnchor: "middle"
  }, "\n                    POST api/v1/CustomEnt...\n                ")))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M 425 370 L 425 310",
    fill: "none",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 350,
    y: 280,
    width: 150,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 148,
      height: 1,
      paddingTop: 295,
      marginLeft: 351
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #FFFFFF; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      fontFamily: "Helvetica",
      color: "rgb(255, 255, 255)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "\n                                POST api/v1/CaseDocument\n                            ")))), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 425,
    y: 299,
    fill: "#FFFFFF",
    fontFamily: "Helvetica",
    fontSize: "14px",
    textAnchor: "middle"
  }, "\n                    POST api/v1/CaseDocum...\n                ")))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M 270 370 L 270 310",
    fill: "none",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 280,
    width: 150,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 148,
      height: 1,
      paddingTop: 295,
      marginLeft: 196
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #FFFFFF; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      fontFamily: "Helvetica",
      color: "rgb(255, 255, 255)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "\n                                POST api/v1/Contact\n                            ")))), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 270,
    y: 299,
    fill: "#FFFFFF",
    fontFamily: "Helvetica",
    fontSize: "14px",
    textAnchor: "middle"
  }, "\n                    POST api/v1/Contact\n                ")))), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 925,
    y: 10,
    width: 160,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 158,
      height: 1,
      paddingTop: 25,
      marginLeft: 926
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #FFFFFF; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      fontFamily: "Helvetica",
      color: "rgb(255, 255, 255)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "\n                                only accessable via authenticated request\n                            ")))), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 1005,
    y: 29,
    fill: "#FFFFFF",
    fontFamily: "Helvetica",
    fontSize: "14px",
    textAnchor: "middle"
  }, "\n                    only accessable via aut...\n                ")))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M 684.67 280 L 556.22 251.38",
    fill: "none",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M 551.09 250.24 L 558.68 248.35 L 556.22 251.38 L 557.16 255.18 Z",
    fill: "#ffffff",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 692,
    y: 370,
    width: 120,
    height: 60,
    fill: "rgb(255, 255, 255)",
    stroke: "#1f1f1f",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 118,
      height: 1,
      paddingTop: 400,
      marginLeft: 693
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "\n                                Relationship\n                            ")))), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 752,
    y: 404,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "14px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "\n                    Relationship\n                ")))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M 752 370 L 752 310",
    fill: "none",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 677,
    y: 280,
    width: 150,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 148,
      height: 1,
      paddingTop: 295,
      marginLeft: 678
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #FFFFFF; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      fontFamily: "Helvetica",
      color: "rgb(255, 255, 255)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "\n                                POST api/v1/Relationship\n                            ")))), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 752,
    y: 299,
    fill: "#FFFFFF",
    fontFamily: "Helvetica",
    fontSize: "14px",
    textAnchor: "middle"
  }, "\n                    POST api/v1/Relations...\n                ")))), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 100,
    width: 140,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 138,
      height: 1,
      paddingTop: 115,
      marginLeft: 131
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #FFFFFF; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      fontFamily: "Helvetica",
      color: "rgb(255, 255, 255)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "\n                                Create new CaseFile\n                            ")))), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 119,
    fill: "#FFFFFF",
    fontFamily: "Helvetica",
    fontSize: "14px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "\n                    Create new CaseFile\n                ")))), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 160,
    width: 160,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 158,
      height: 1,
      paddingTop: 175,
      marginLeft: 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #FFFFFF; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      fontFamily: "Helvetica",
      color: "rgb(255, 255, 255)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "\n                                POST api/v1/CaseFile\n                            ")))), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 179,
    fill: "#FFFFFF",
    fontFamily: "Helvetica",
    fontSize: "14px",
    textAnchor: "middle"
  }, "\n                    POST api/v1/CaseFile\n                ")))), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 280,
    width: 150,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 148,
      height: 1,
      paddingTop: 295,
      marginLeft: 196
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #FFFFFF; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      fontFamily: "Helvetica",
      color: "rgb(255, 255, 255)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "\n                                POST api/v1/Contact\n                            ")))), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 270,
    y: 299,
    fill: "#FFFFFF",
    fontFamily: "Helvetica",
    fontSize: "14px",
    textAnchor: "middle"
  }, "\n                    POST api/v1/Contact\n                ")))), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 350,
    y: 280,
    width: 150,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 148,
      height: 1,
      paddingTop: 295,
      marginLeft: 351
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #FFFFFF; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      fontFamily: "Helvetica",
      color: "rgb(255, 255, 255)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "\n                                POST api/v1/CaseDocument\n                            ")))), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 425,
    y: 299,
    fill: "#FFFFFF",
    fontFamily: "Helvetica",
    fontSize: "14px",
    textAnchor: "middle"
  }, "\n                    POST api/v1/CaseDocum...\n                ")))), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 500,
    y: 280,
    width: 150,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 148,
      height: 1,
      paddingTop: 295,
      marginLeft: 501
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #FFFFFF; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      fontFamily: "Helvetica",
      color: "rgb(255, 255, 255)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "\n                                POST api/v1/CustomEntity\n                            ")))), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 575,
    y: 299,
    fill: "#FFFFFF",
    fontFamily: "Helvetica",
    fontSize: "14px",
    textAnchor: "middle"
  }, "\n                    POST api/v1/CustomEnt...\n                ")))), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 677,
    y: 280,
    width: 150,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 148,
      height: 1,
      paddingTop: 295,
      marginLeft: 678
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #FFFFFF; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      fontFamily: "Helvetica",
      color: "rgb(255, 255, 255)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "\n                                POST api/v1/Relationship\n                            ")))), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 752,
    y: 299,
    fill: "#FFFFFF",
    fontFamily: "Helvetica",
    fontSize: "14px",
    textAnchor: "middle"
  }, "\n                    POST api/v1/Relations...\n                ")))), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 415,
    y: 100,
    width: 190,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 188,
      height: 1,
      paddingTop: 115,
      marginLeft: 416
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #FFFFFF; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      fontFamily: "Helvetica",
      color: "rgb(255, 255, 255)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "\n                                Add data (entities) to CaseFile\n                            ")))), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 510,
    y: 119,
    fill: "#FFFFFF",
    fontFamily: "Helvetica",
    fontSize: "14px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "\n                    Add data (entities) to Case...\n                ")))), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 662,
    y: 160,
    width: 150,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 148,
      height: 1,
      paddingTop: 175,
      marginLeft: 663
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #FFFFFF; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      fontFamily: "Helvetica",
      color: "rgb(255, 255, 255)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "\n                                POST api/v1/CaseFile/Submit\n                            ")))), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 737,
    y: 179,
    fill: "#FFFFFF",
    fontFamily: "Helvetica",
    fontSize: "14px",
    textAnchor: "middle"
  }, "\n                    POST api/v1/CaseFile/...\n                ")))), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 925,
    y: 10,
    width: 160,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 158,
      height: 1,
      paddingTop: 25,
      marginLeft: 926
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #FFFFFF; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      fontFamily: "Helvetica",
      color: "rgb(255, 255, 255)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "\n                                only accessable via authenticated request\n                            ")))), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    x: 1005,
    y: 29,
    fill: "#FFFFFF",
    fontFamily: "Helvetica",
    fontSize: "14px",
    textAnchor: "middle"
  }, "\n                    only accessable via aut...\n                ")))), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 945,
    y: 100,
    width: 120,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 118,
      height: 1,
      paddingTop: 115,
      marginLeft: 946
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #FFFFFF; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      fontFamily: "Helvetica",
      color: "rgb(255, 255, 255)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "\n                                Submit CaseFile\n                            ")))), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    x: 1005,
    y: 119,
    fill: "#FFFFFF",
    fontFamily: "Helvetica",
    fontSize: "14px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "\n                    Submit CaseFile\n                ")))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M 965 150 L 1015 150 L 1045 180 L 1045 250 L 965 250 L 965 150 Z",
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M 1015 150 L 1015 180 L 1045 180 Z",
    fillOpacity: 0.05,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M 1015 150 L 1015 180 L 1045 180",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 78,
      height: 1,
      paddingTop: 200,
      marginLeft: 966
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "\n                                CaseFile\n                            ")))), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    x: 1005,
    y: 204,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "14px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "\n                    CaseFile\n                ")))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M 470 150 L 520 150 L 550 180 L 550 250 L 470 250 L 470 150 Z",
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M 520 150 L 520 180 L 550 180 Z",
    fillOpacity: 0.05,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M 520 150 L 520 180 L 550 180",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 78,
      height: 1,
      paddingTop: 200,
      marginLeft: 471
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "\n                                CaseFile\n                            ")))), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    x: 510,
    y: 204,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "14px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "\n                    CaseFile\n                "))))), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", {
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }), /*#__PURE__*/React.createElement("a", {
    transform: "translate(0,-5)",
    xlinkHref: "https://www.diagrams.net/doc/faq/svg-export-text-problems",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    fontSize: "10px",
    x: "50%",
    y: "100%"
  }, "\n                Text is not SVG - cannot display\n            ")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestdrawio);
export default __webpack_public_path__ + "static/media/test.drawio.f61b97e7d7caf1a41e8f6aad3106822f.svg";
export { ForwardRef as ReactComponent };